import { EventTypes } from 'redux-segment';

import H from 'constants/httpMethod.const';
import { AUTH_API } from 'middleware/api';
import authenticatedEndpoint from 'utils/backend/authenticatedEndpoint.util';
import jsonEndpoint from 'utils/backend/jsonEndpoint.util';
import logger from 'utils/logger.util';

import { ADD_ROLE_FAILURE, ADD_ROLE_REQUEST, ADD_ROLE_SUCCESS } from './addRole.types';

const ATAG = 'addRole';
const L = logger('addRole');

const addRole = L.wrap('()', ({ salonId, name, copyFromId }) => ({
  ATAG,
  [AUTH_API]: {
    ...authenticatedEndpoint({ pinSafe: true }),
    ...jsonEndpoint(H.post, `services/v1/role/salon/${salonId}/`, { name, copy_role_id: copyFromId || undefined }),
    types: [ADD_ROLE_REQUEST, ADD_ROLE_SUCCESS, ADD_ROLE_FAILURE],
  },
  meta: { analytics: { eventType: EventTypes.track, eventPayload: { event: ATAG, properties: { name } } } },
}));

// noinspection JSUnusedGlobalSymbols
export default addRole;
